import React, { useState, useMemo } from 'react';
import { useField } from 'formik';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import makeStyles from '@material-ui/core/styles/makeStyles';

const DISTRICTS = [
  'Akmenės r. sav.',
  'Alytaus m. sav.',
  'Alytaus r. sav.',
  'Anykščių r. sav.',
  'Birštono sav.',
  'Biržų r. sav.',
  'Druskininkų sav.',
  'Elektrėnų sav.',
  'Ignalinos r. sav.',
  'Jonavos r. sav.',
  'Joniškio r. sav.',
  'Jurbarko r. sav.',
  'Kaišiadorių r. sav.',
  'Kalvarijos sav.',
  'Kauno m. sav.',
  'Kauno r. sav.',
  'Kazlų Rūdos sav.',
  'Kelmės r. sav.',
  'Kėdainių r. sav.',
  'Klaipėdos m. sav.',
  'Klaipėdos r. sav.',
  'Kretingos r. sav.',
  'Kupiškio r. sav.',
  'Lazdijų r. sav.',
  'Marijampolės sav.',
  'Mažeikių r. sav.',
  'Molėtų r. sav.',
  'Neringos sav.',
  'Pagėgių sav.',
  'Pakruojo r. sav.',
  'Palangos m. sav.',
  'Panevėžio m. sav.',
  'Panevėžio r. sav.',
  'Pasvalio r. sav.',
  'Plungės r. sav.',
  'Prienų r. sav.',
  'Radviliškio r. sav.',
  'Raseinių r. sav.',
  'Rietavo sav.',
  'Rokiškio r. sav.',
  'Šakių r. sav.',
  'Šalčininkų r. sav.',
  'Šiaulių m. sav.',
  'Šiaulių r. sav.',
  'Šilalės r. sav.',
  'Šilutės r. sav.',
  'Širvintų r. sav.',
  'Skuodo r. sav.',
  'Švenčionių r. sav.',
  'Tauragės r. sav.',
  'Telšių r. sav.',
  'Trakų r. sav.',
  'Ukmergės r. sav.',
  'Utenos r. sav.',
  'Varėnos r. sav.',
  'Vilkaviškio r. sav.',
  'Vilniaus m. sav.',
  'Vilniaus r. sav.',
  'Visagino sav.',
  'Zarasų r. sav.',
];

const useStyles = makeStyles((theme) => ({
  searchField: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
}));

const DistrictSelectField = ({ name, label, fullWidth, ...props }) => {
  const classes = useStyles();
  const [field, meta, helpers] = useField(name);
  const [searchValue, setSearchValue] = useState('');
  const [open, setOpen] = useState(false);

  const filteredDistricts = useMemo(() => {
    if (!searchValue) {
      return DISTRICTS;
    }
    const searchLower = searchValue.toLowerCase();
    return DISTRICTS.filter((district) =>
      district.toLowerCase().includes(searchLower),
    );
  }, [searchValue]);

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    setSearchValue('');
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSearchValue('');
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <FormControl
      variant="outlined"
      fullWidth={fullWidth}
      error={meta.touched && !!meta.error}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        {...field}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        onChange={handleChange}
        value={field.value || ''}
        label={label}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 400,
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
        {...props}
      >
        <div
          style={{
            height: 'auto',
            padding: 12,
            position: 'sticky',
            top: 0,
            background: '#fff',
            zIndex: 100,
            width: '100%',
          }}
        >
          <TextField
            placeholder="Ieškoti..."
            value={searchValue}
            onChange={handleSearchChange}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => {
              e.stopPropagation();
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            variant="outlined"
            size="small"
            className={classes.searchField}
            autoFocus
          />
        </div>
        {filteredDistricts.map((district) => (
          <MenuItem key={district} value={district}>
            {district}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default DistrictSelectField;
export { DISTRICTS };
